import { Component } from '@angular/core';

@Component({
    selector: 'ws-save-as-icon',
    templateUrl: './saveAsIcon.component.html',
    styleUrls: ['./saveAsIcon.component.scss'],
    standalone: false
})
export class SaveAsIconComponent {
}
